export const getRowChip = (row: string[]) => row[0].trim().toLowerCase();

export const getRowFieldQualifierValue = (row: string[]) => row[1];
